<template>
  <div>
    <!-- <div> -->
    <el-dropdown trigger="hover">
      <el-button type="primary">
        新建批次<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="create(1,1,1)">有码产品</el-dropdown-item>
        <el-dropdown-item @click.native="create(1,1,9)">无码产品</el-dropdown-item>
        <el-dropdown-item @click.native="create(1,0,1)">有码样品</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <!-- <product-select-modal ref="select" />
  </div> -->
    <!-- <el-button
    type="primary"
    @click="create(1)">
    新建批次
  </el-button> -->
    <warehouse-select-modal
      ref="warehouse"
      :callback="warehouseCallback" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { querystring } from '@/utils/index'
import WarehouseSelectModal from '../../orders/busi/warehouse-select-modal.vue'
// import ProductSelectModal from './product-select-modal'
export default {
  name: 'CreateBatchBtn',
  components: { WarehouseSelectModal },
  data() {
    return {
      tagModels: [],
      options: { tagModel: null, needSyncInventory: null, codingType: null }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    })
  },
  mounted() {
    // this.getvendor()
  },
  methods: {
    warehouseCallback(row) {
      const { warehouseId, warehouseName, warehouseNo } = row
      const search = querystring({
        ...this.options,
        warehouseId,
        warehouseName,
        warehouseNo,
        vendorId: this.userInfo.orgId
      })
      this.$router.push(`/batch-create${search}`)
    },
    create(tagModel, needSyncInventory, codingType) {
      this.$refs.warehouse.fetch({ productType: 1 })
      this.options = { ...this.options, tagModel, needSyncInventory, codingType }
      // this.$refs.select.fetch({
      //   tagTypes: type === '1' ? [1, 2, 3, 4] : [2, 3, 4]
      // })
    }
    // getvendor() {
    //   this.$store.dispatch('vendor/getvendor', {
    //     payload: {
    //       vendorId: this.userInfo.orgId
    //     },
    //     success: (res) => {
    //       res.data.tagModels = res.data.tagModels.split(',')
    //       this.tagModels = res.data.tagModels
    //     },
    //     fail: () => {
    //       this.tagModels = []
    //     }
    //   })
    // }
  }
}
</script>
